import { useEffect, useState } from 'react';

import { useAuth } from '../../../hooks/useAuth';
import { labPanelsService } from '../../../services/labPanelsService';
import { onLabQueueChanged } from './labQueueBus';

// A doctor or nutritionist has assigned patients; an admin does not, so the
// badge counts the whole clinic for them. A default, not a permission.
const ASSIGNED_ROLES = new Set(['doctor', 'nutritionist']);

/**
 * Panels waiting for the caller: their own patients for a doctor or
 * nutritionist, the whole clinic for an admin (who has no assigned patients). `null` until answered, and
 * again when the backend has no module yet (404), so the badge is absent
 * rather than zero.
 */
export function useLabInboxCount(): number | null {
  const { user } = useAuth();
  const role = user?.role ?? '';
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    const read = () => {
      labPanelsService
        .listQueue({ assigned: ASSIGNED_ROLES.has(role) ? 'me' : 'clinic', perpage: 1 })
        .then((page) => {
          if (!cancelled) setCount(page.count ?? 0);
        })
        .catch(() => {
          if (!cancelled) setCount(null);
        });
    };
    read();
    const off = onLabQueueChanged(read);
    return () => {
      cancelled = true;
      off();
    };
  }, [user, role]);

  return count;
}
